import API from 'js/lib/api';

export default API('/api/credentialTrackSubscriptions.v1', {
  type: 'rest',
});
